import React, { useEffect, useState } from "react";
import baglight from "../../../images/bag-light.png";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
// import eye from "../../images/eye-slash-light.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { LoginUser } from "../../../redux/authslice";

const Login = () => {
  const [error, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const Validation = () => {
    const errors = {};
    if (loginData?.email === "" && loginData?.email?.length === 0) {
      errors.email = "Email required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(loginData?.email)
    ) {
      errors.email = "Invalid email address";
    }
    if (loginData?.password === "" && loginData?.password?.length === 0) {
      errors.password = "Password required";
    }
    setErrors(errors);
    const hasErrors = Object.keys(errors)?.length > 0;
    if (hasErrors) {
      return true;
    } else {
      return false;
    }
  };

  const HandleChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value,
    });
    setErrors({ ...error, [e.target.name]: undefined });
  };

  const HandleLogin = (e) => {
    e?.preventDefault();
    let data = Validation();
    if (data) {
      return;
    } else {
      dispatch(LoginUser({ loginData, navigate, setLoginData, dispatch }));
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <>
      <div className="login-page-2">
        <p className="accout-p-log">Log in to your account</p>
        <div className="mar-15">
          <label className="label1" htmlFor="">
            Email
          </label>
          <input
            type="text"
            name="email"
            className="all-input"
            placeholder="Enter email"
            value={loginData.email}
            onChange={(e) => HandleChange(e)}
          />
          <p className="error_text">{error.email}</p>
        </div>
        <div className="mar-15">
          <label className="label1" htmlFor="">
            Password
          </label>
          <div className="relative-div">
            <input
              className="all-input"
              placeholder="Enter password"
              type={showPassword ? "text" : "password"}
              name="password"
              onChange={(e) => HandleChange(e)}
            />

            <img src={baglight} className="bag-light" alt="" />
            {/* <img src={eye} className="bag-light-1" alt="" /> */}
            <FontAwesomeIcon
              icon={showPassword ? faEyeSlash : faEye}
              className="bag-light-1"
              onClick={togglePasswordVisibility}
            />
          </div>
          <p className="error_text">{error.password}</p>
        </div>
        <div className="mar-15">
          <a
            className="Forgot-password"
            href="/forgot"
            onClick={() => {
              localStorage.setItem("type", "forgot");
              localStorage.removeItem("2FA");
            }}
          >
            Forgot password?
          </a>
        </div>
        <div className="mar-15" onClick={HandleLogin}>
          <button className="login-bt">Log In</button>
        </div>
        <div className="mar-15">
          <p className="Sign-up-edu">
            New to EduBridge Classroom?<Link to="/signup">Sign up</Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default Login;
